import React from 'react';
import { classNames } from '../../utils/classUtils';

export function EditFormGroupModal({ hasError, children }): JSX.Element {
  return (
    <div
      className={classNames(
        { 'has-error': hasError },
        'edit-user-modal__form-group'
      )}
    >
      {children}
    </div>
  );
}
